import { BREAKPOINTS } from '../constants/screenSizes.constants';

export const getMinScreenWidths = Object.keys(BREAKPOINTS).reduce(
  (acc, label) => {
    const newAcc = { ...acc };
    newAcc[label] = `@media (min-width: ${BREAKPOINTS[label]}px)`;
    return newAcc;
  },
  {} as {
    [key: string]: string;
  },
);

export const getMaxScreenWidths = Object.keys(BREAKPOINTS).reduce(
  (acc, label) => {
    const newAcc = { ...acc };
    newAcc[label] = `@media (max-width: ${BREAKPOINTS[label]}px)`;
    return newAcc;
  },
  {} as {
    [key: string]: string;
  },
);
